import store from '@/store';

const setIsLoading = (isLoading: boolean): void => {
    store.dispatch('AppModule/setIsLoading', isLoading);
};

export {
    setIsLoading,
};
